import * as React from 'react';
import { LinkButton } from '../../Common/LinkButton';
import './style.css';

export interface SignUpBoxProps {
  /* empty */
}

export interface SignUpBoxState {
  /* empty */
}

export class SignUpBox extends React.Component<SignUpBoxProps, SignUpBoxState> {
  render() {
    return (
      <div className="sign-up-box">
        <h1 className="sign-up-box-heading">WHY EDGE OF PLAY?</h1>
        <p className="sign-up-box-description">
          We are grassroots coaches who are passionate about football coaching
          and want to share this with you. Our website supports fellow
          grassroots coaches through hundreds of coaching videos covering
          technical, tactical, small-sided games, physical and mental
          disciplines.
        </p>
        <LinkButton className="sign-up-box-link" to="/sign-up">
          Sign Up Now
        </LinkButton>
      </div>
    );
  }
}

export default SignUpBox;



// WEBPACK FOOTER //
// ./src/app/components/Home/SignUpBox/index.tsx